import { useRouter } from 'next/router'

import { useSatuEventTracker } from 'utils/satuEvent'
import AndroidHandler from 'utils/androidHandler'
import { useAuth } from 'utils/auth'
import { APP_DEVICE_ID_STORAGE_KEY } from 'configs/android'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

type TSETrackEventDefaultAtributes = {
  screen_name: string
  is_login: [boolean, 'bool']
  is_webview: [boolean, 'bool']
  email: string
  profile_user_id: string
}

const SATU_EVENT_NAME = 'guru_core_pwa_event_tracker_v1'
const TRACKER_EVENT_NAME = 'GURU_CORE_APP'
const TRACKER_SCREEN_NAME = 'PROFILE_PAGE'
const DEFAULT_TIMEOUT = 5000 // 5 seconds

export const useSETrackEventCertificates = () => {
  const [, , , getAppDeviceIdValue] = useLocalStorage(
    APP_DEVICE_ID_STORAGE_KEY,
    null
  )
  const { query } = useRouter()
  const { id: profileId } = query

  const appDeviceID = getAppDeviceIdValue()
  const hasAppDeviceID = Boolean(appDeviceID)
  const androidHandler = AndroidHandler()
  const { session } = useAuth()
  const { SETrackEvent, SETransformAttrs } = useSatuEventTracker()

  const SETrackEventDefaultAtributes: TSETrackEventDefaultAtributes = {
    screen_name: TRACKER_SCREEN_NAME,
    is_login: [Boolean(session), 'bool'],
    is_webview: [androidHandler.enabled, 'bool'],
    email: session?.user?.email ?? null,
    profile_user_id: profileId as string,
  }

  const SETrackComponent = (
    activity_type: string,
    additionalAttributes?: Record<string, any>
  ): void => {
    SETrackEvent({
      eventName: SATU_EVENT_NAME,
      eventParams: {
        activity_type,
        event_name: TRACKER_EVENT_NAME,
        user_id: session?.user?.id,
        ...(hasAppDeviceID ? { device_id: appDeviceID } : {}),
        attributes: SETransformAttrs({
          ...SETrackEventDefaultAtributes,
          event_trigger: TRACKER_SCREEN_NAME,
          ...additionalAttributes,
        }),
      },
      timeout: DEFAULT_TIMEOUT,
      keepAlive: true,
    })
  }

  const SETrackCertificateList = (
    activityType: string,
    additionalAttributes?: Record<string, any>
  ): void => {
    SETrackComponent(activityType, {
      page_element: 'SERTIFIKAT',
      ...additionalAttributes,
    })
  }

  const SETrackCertificateError = (
    activityType: string,
    additionalAttributes?: Record<string, any>
  ): void => {
    SETrackComponent(activityType, {
      screen_name: '',
      ...additionalAttributes,
    })
  }

  return {
    SETrackCertificateList,
    SETrackCertificateError,
  }
}
